/**
 * This class wraps the history object from the old code and provides access to it in the new modules.
 * Considering our goal to migrate to a newer version of react-router(or any other router library),
 * we target to reduce the amount of code that is directly using the current(v3) version of react-router.
 */
var RouterBridge = /** @class */ (function () {
    function RouterBridge() {
    }
    RouterBridge.setUpListeners = function () {
        RouterBridge.history.listen(function (params) {
            RouterBridge.afterChangeListeners.forEach(function (listener) { return listener(params); });
        });
        RouterBridge.history.listenBefore(function (params) {
            RouterBridge.beforeChangeListeners.forEach(function (listener) { return listener(params); });
        });
    };
    RouterBridge.configure = function (history) {
        RouterBridge.history = history;
        RouterBridge.setUpListeners();
    };
    RouterBridge.push = function (path) {
        RouterBridge.history.push(path);
    };
    RouterBridge.replace = function (path) {
        RouterBridge.history.replace(path);
    };
    /**
     * This method is being called by router enter and change hooks installed on the root route.
     * It's being used to sync params and query from the router to the new modules.
     */
    RouterBridge.setParams = function (params) {
        RouterBridge.params = params;
        RouterBridge.paramsChangeListeners.forEach(function (listener) { return listener(params); });
    };
    RouterBridge.getParamsOnce = function () {
        return RouterBridge.params;
    };
    RouterBridge.subscribeToParams = function (listener) {
        RouterBridge.paramsChangeListeners.push(listener);
        return function () {
            RouterBridge.unsubscribeFromParams(listener);
        };
    };
    RouterBridge.unsubscribeFromParams = function (listener) {
        RouterBridge.paramsChangeListeners = RouterBridge.paramsChangeListeners.filter(function (l) { return l !== listener; });
    };
    RouterBridge.subscribeOnAfterChange = function (listener) {
        RouterBridge.afterChangeListeners.push(listener);
        return function () {
            RouterBridge.unsubscribeOnAfterChange(listener);
        };
    };
    RouterBridge.unsubscribeOnAfterChange = function (listener) {
        RouterBridge.afterChangeListeners = RouterBridge.afterChangeListeners.filter(function (l) { return l !== listener; });
    };
    RouterBridge.subscribeOnBeforeChange = function (listener) {
        RouterBridge.beforeChangeListeners.push(listener);
        return function () {
            RouterBridge.unsubscribeOnBeforeChange(listener);
        };
    };
    RouterBridge.unsubscribeOnBeforeChange = function (listener) {
        RouterBridge.beforeChangeListeners = RouterBridge.beforeChangeListeners.filter(function (l) { return l !== listener; });
    };
    RouterBridge.params = {
        params: {},
        query: {},
    };
    RouterBridge.paramsChangeListeners = [];
    RouterBridge.afterChangeListeners = [];
    RouterBridge.beforeChangeListeners = [];
    return RouterBridge;
}());
export { RouterBridge };
